<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('banner_overview.page_title') }}</slot>
            <slot slot="description">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/banners/create">{{ $t('banner_overview.create') }}</router-link>
            </slot>
        </page-header>

        <v-overview-list
            prefix="a1"
            data-table="Banners"
            data-pagination="BannersPagination"
            btnViewPath="BannersEdit"
            :table-columns="Columns"
            :page-size="12">

            <template slot="placeholderButtonsFooter">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/banners/create">{{ $t('banner_overview.create') }}</router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            Columns() {
                return [
                  {
                      value: 'Name',
                      name: this.$t('banner_overview.columns.name'),
                      sortable: false
                  },
                  {
                      value: 'StartDate',
                      name: this.$t('banner_overview.columns.start_date'),
                      type: 'Date',
                      sortable: false
                  },
                  {
                      value: 'EndDate',
                      name: this.$t('banner_overview.columns.end_date'),
                      type: 'Date',
                      sortable: false
                  },
                  {
                      value: 'Weight',
                      name: this.$t('banner_overview.columns.weight'),
                      sortable: false
                  }
              ];
            }
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/banners/Overview.vue